var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServerSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 59 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M54.392,19H3.608C1.616,19,0,17.384,0,15.392V3.608C0,1.616,1.616,0,3.608,0h50.783 C56.384,0,58,1.616,58,3.608v11.783C58,17.384,56.384,19,54.392,19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M54.392,38H3.608C1.616,38,0,36.384,0,34.392V22.608C0,20.616,1.616,19,3.608,19h50.783 C56.384,19,58,20.616,58,22.608v11.783C58,36.384,56.384,38,54.392,38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M54.392,57H3.608C1.616,57,0,55.384,0,53.392V41.608C0,39.616,1.616,38,3.608,38h50.783 C56.384,38,58,39.616,58,41.608v11.783C58,55.384,56.384,57,54.392,57z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 9.5,
    cy: 9.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 49,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 45,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 51,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 47,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 41,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 43,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 37,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 39,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 33,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 35,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 9.5,
    cy: 28.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 49,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 45,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 51,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 47,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 41,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 43,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 37,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 39,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 33,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 35,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 9.5,
    cy: 47.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 49,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 45,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 51,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 47,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 41,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 43,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 37,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 39,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 33,
    cy: 46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8697CB"
    },
    cx: 35,
    cy: 49,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43,
    style: {
      fill: "#B1D3EF"
    },
    width: 20,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M52,50c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,1.317,0.854,2.424,2.035,2.827 C48.024,52.885,48,52.939,48,53v2c0,0.552,0.448,1,1,1s1-0.448,1-1v-2c0-0.061-0.024-0.115-0.035-0.173 C51.146,52.424,52,51.317,52,50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M44,41c0-2.757,2.243-5,5-5s5,2.243,5,5v2h2v-2c0-3.86-3.14-7-7-7s-7,3.14-7,7v2h2V41z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerSvgrepoCom);
export default __webpack_public_path__ + "static/media/server-svgrepo-com.4678dc4cc4ee05c971a3a9bacc58b34a.svg";
export { ForwardRef as ReactComponent };